import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useAuth } from "../authProvider/AuthContextProvider";

const StaffRoute = () => {
  const { user, token, isLoading } = useAuth();
  let location = useLocation();

  if (isLoading) {
    return <CircularProgress />;
  }
  if (token && user.email && user.status === true && user.roleCode === 2) {
    return <Outlet />;
  }
  return <Navigate to="/" state={{ from: location }} />;
};

export default StaffRoute;
